import { Link } from '@/navigation';
import { Page } from '@/payload/payload-types';
import RichTextLexical from '../../_components/RichTextLexical';

type MenuTilesType = Extract<Page['layoutBlocks'][0], { blockType: 'menuTiles' }>;
type MenuTilesProps = Omit<MenuTilesType, 'blockType'>;

export const MenuTiles: React.FC<MenuTilesProps> = ({ menuTitle, tiles }) => {
	return (
		<section className="flex flex-col space-y-6 lg:space-y-10">
			{menuTitle && (
				<h2 className="text-muted-navy text-2xl leading-10 font-normal lg:text-5xl lg:leading-[48px] lg:font-light">
					<RichTextLexical content={menuTitle} />
				</h2>
			)}

			<div
				className={`grid grid-cols-2 gap-2 lg:gap-4 ${
					tiles.length > 6 ? 'lg:grid-cols-4' : 'lg:grid-cols-3'
				}`}
			>
				{tiles.map(tile => {
					if (typeof tile.reference.value === 'string') {
						throw new Error('bad depth for tile reference value at <MenuTiles/>');
					}

					if (!tile.reference.value.fullSlug) {
						throw new Error('no fullslug for tile reference values at <MenuTiles/>');
					}

					return (
						<Link
							// @ts-expect-error reference link is defined in admin view
							href={tile.reference.value.fullSlug}
							className="bg-muted-blue hover:bg-muted-blue-light hover:text-muted-navy flex h-24 cursor-pointer items-center justify-center rounded-2xl p-4 text-center text-sm leading-6 font-bold text-white transition duration-300 ease-out hover:transition-all lg:h-[200px] lg:rounded-4xl lg:p-8 lg:text-base"
							key={tile.id}
						>
							<RichTextLexical className="line-clamp-2" content={tile.title} />
						</Link>
					);
				})}
			</div>
		</section>
	);
};
